import NavigationManager from './NavigationManager';

export class FolderPaneNavigationManager {
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
     *	> Function NavigationManager called at module scope is not allowed. This may cause unwanted side effects. */
    private static instance = new NavigationManager();

    public static init(ref: React.RefObject<HTMLElement | null>): void {
        const self = FolderPaneNavigationManager;
        self.instance.init(ref);
    }

    public static handleInput(event: React.KeyboardEvent): void {
        FolderPaneNavigationManager.instance.handleInput(event);
    }

    public static resetSearchResults(): void {
        FolderPaneNavigationManager.instance.resetSearchResults();
    }
}
